export default {
  title: 'Account settings',
  subtitle: 'Manage your personal information and security preferences',

  nav: {
    sections: {
      personal: 'Personal info',
      password: 'Password',
      kyc: 'Security & KYC',
      email: 'Email preferences',
    },
    signOut: 'Sign out',
  },

  personal: {
    description: 'Your name, address and phone. Needed to buy and to top up the wallet.',
    title: 'Personal information',
    completeProfileTitle: 'Complete your profile before your first purchase',
    completeProfileMissing: 'Still needed:',
    fields: {
      firstName: 'First name',
      lastName: 'Last name',
      emailAddress: 'Email address',
      country: 'Country',
      dateOfBirth: 'Date of birth',
      address: 'Address',
      addressPlaceholder: 'Street, house number, apartment',
      city: 'City',
      postalCode: 'Postal code',
      phone: 'Phone',
      phoneCountryCode: 'Phone country code',
    },
    badges: {
      verified: 'Verified',
      unverified: 'Unverified',
    },
    save: 'Save changes',
    savedOk: 'Saved.',
    saveError: 'Could not save profile.',
  },

  password: {
    description: 'Use a strong password you do not use anywhere else.',
    title: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    hint: 'Min 8 characters, must contain a letter and a digit.',
    strength: {
      weak: 'Weak',
      ok: 'OK',
      strong: 'Strong',
    },
    update: 'Update password',
    updating: 'Updating…',
    updatedOk: 'Password updated. Other sessions have been signed out.',
    updateError: 'Could not change password.',
    errorTooShort: 'New password must be at least 8 characters and contain a letter and a digit.',
    errorMismatch: 'New password and confirmation do not match.',
  },

  kyc: {
    description: 'Identity check for larger purchases.',
    title: 'KYC verification',
    statusApproved: 'Identity Verified',
    statusPending: 'KYC under review',
    statusNone: 'KYC not started',
    approvedOn: 'Approved on {date}',
    pendingNote: "We'll email you once a decision is made.",
    noneNote: 'Required for purchases over €50. Takes under 5 minutes.',
    warning: 'Important: Make sure your account personal information (name, address, date of birth) matches the details on your documents before submitting.',
    dropHint: 'Drop a file here or click to choose · PDF, JPG, PNG',
    dropActive: 'Drop to attach',
    idProofLabel: 'ID proof (front + back, max 2 files)',
    addressProofLabel: 'Proof of address (utility bill, bank statement)',
    submit: 'Submit KYC verification',
    submitting: 'Submitting...',
    reReview: 'Request re-review',
    reviewRequested: 'Review requested',
    successMessage: 'KYC review requested. Documents sent for review.',
    errorNoId: 'Please upload at least one ID proof file.',
    errorNoAddress: 'Please upload a proof of address file.',
    errorGeneric: 'Could not request KYC.',
  },

  emailPrefs: {
    description: 'What we send to your inbox.',
    title: 'Email preferences',
    body: 'Email preferences aren\'t configurable yet. Transactional emails (order receipts, key delivery, password resets) are always sent. Marketing emails are not used.',
    unsubscribe: 'To unsubscribe entirely, contact',
  },
};
